import api, { request } from '../../../../api';
import { IStore } from '../../../index';
import { IEventEnrollment } from '../store';
import { IEventsActionResponse } from '../Utils/TEventsActionResponse';

export const setMessage = async (
  state: IStore,
  eventId: number,
  message: string
): Promise<IEventsActionResponse> => {
  const enrollmentId = state.events[eventId].enrollment.id;
  const response = await request.patch(`${api.eventRegistration}${enrollmentId}/`, {
    player_note: message
  });

  if (response.error) {
    return { errors: { events: { msg: 'Error sending message to administrator.' } } };
  }

  const enrollment: IEventEnrollment = response;
  const event = state.events[eventId];
  return {
    events: {
      ...state.events,
      [eventId]: {
        ...event,
        enrollment
      }
    }
  };
};
